import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-all-machines-added',
  templateUrl: './all-machines-added.component.html',
  styleUrls: ['./all-machines-added.component.css']
})
export class AllMachinesAddedComponent implements OnInit {
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  closePopup(): void {
    this.callOnPositiveBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

}
